export function buildOrigin() {
	return `${window.location.protocol}//${window.location.host}/api/`;
}



// WEBPACK FOOTER //
// ./src/config/helpers.js